import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
import { SESSION_DATA, user, currentIp, BASE_IMG_URL } from "../../../constants";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../../components/tables/table";
import {
  userBookSlotFieldData,
  userBookSlotTableData,
} from "../../../data/TableData";
import { PAGE_LIMITS, modulePermissions } from "../../../constants";
import BookSlotTable from "../../../components/tables/BookSlotTable";
import { GrUserExpert } from "react-icons/gr";
import { IoIosArrowBack } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { MdReviews } from "react-icons/md";
import ViewSubDomainAlert from "../../../components/dashboard/ViewSubDomainAlert";

const AddUserBookSlot = () => {
  const { user } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const { id } = useParams();
  const MODULE_URI = "/user/userlisting/userbookslot";
  const GET_DOMAIN_URI = "master/getDomainsData";
  const SUBMIT_FORM_DATA_URL = "expert/getExpertByDomain";
  const GET_STATE_DIST_URL = `master/getStateDistrictData`;
  const GET_STATE_BY_LOC = `master/getStateByLocationData`;


  const [domainData, errorDomain, loadingDomain, axiosFetchDomain] = useAxios();
  const [resData, errorSubmit, loadingSubmit, axiosSubmit] = useAxios();
  const [locationData, errorLocation, loadingLocation, axiosLocation] = useAxios();
  const [stateDistData, errorStateDist, loadingStateDist, axiosFetchStateDist] =  useAxios();
  const [domainSubDomainData, errorinSubDomain, loadingDomainSubDomain, axiosDomainSubDomain] =  useAxios();
  const [stateByLocData, errorStateByLoc, loadingStateByLoc, axiosFetchStateByLoc] =  useAxios();
  

  //   const { SESSION_DATA, user } = useSelector((state) => state.user);

  const [page, setPage] = useState(0);
  const [addUpdate, setAddUpdate] = useState(false);
  const [subDomainFlag, setSubDomainFlag] = useState(null);
  const [DomainDataFlag, setDomainDataFlag] = useState([]);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [totalCount, setTotalCount] = useState(0);

  const [tableData, setTableData] = useState([]);
  const [locationFlag, setLocationFlag] = useState(false);
  const [bookingMode, setBookingMode] = useState("");
  const [bookingLoc, setBookingLoc] = useState("");
  const [stateDistInfo, setStateDistInfo] = useState([]);
  const [currState, setCurrState] = useState({});
  const [districtData, setDistrictData] = useState([]);
  const [currDistrict, setCurrDistrict] = useState({});
  const [locationNotiFlag, setLocationNotiFlag] = useState(false);
  const [stateByLoc, setStateByLoc] = useState([]);
  const [districtByLoc, setDistrictByLoc] = useState([]);
   const [alertData,setAlertData] =useState("");
    const [modalOpen,setModalOpen] =useState(false);



        const getStateData = (url) => {
              axiosFetchStateDist({
                  axiosInstance: axiosInstance,
                  url: url,
                  method: "GET",
                });
          };
        const getStateByLocationData = (url) => {
              axiosFetchStateByLoc({
                  axiosInstance: axiosInstance,
                  url: url,
                  method: "GET",
                });
          };
      
           useEffect(() => {
              getStateData(GET_STATE_DIST_URL);   
          },[GET_STATE_DIST_URL]);

           useEffect(() => {
              getStateByLocationData(GET_STATE_BY_LOC);   
          },[GET_STATE_BY_LOC]);
      
          useEffect(() => {
            setStateDistInfo(stateDistData?.[0]?.StateDistrictsData) 
        },[loadingStateDist]);

          useEffect(() => {
            if(stateByLocData?.[0]?.success){
            setStateByLoc(stateByLocData?.[0]?.data?.distinctStates); 
            setDistrictByLoc(stateByLocData?.[0]?.data?.distinctDistricts) 
            }else{
              setStateByLoc([])
              setDistrictByLoc([])
            }
        },[loadingStateByLoc]);
  

  const form = useForm({
    defaultValues: {
      mode:"offline"
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;
  const getDomainData = (url) => {
    axiosFetchDomain({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

   const getLocationData = (url) => {
      axiosLocation({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };
    const getDomainSubDomainData = (url) => {
      axiosDomainSubDomain({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

    //  useEffect(() => {
    //     getLocationData(FETCH_LOC_URL);
    //   }, [FETCH_LOC_URL]);

  // useEffect(() => {
  //   getDomainData(GET_DOMAIN_URI);
  // }, [GET_DOMAIN_URI]);

  // useEffect(() => {
  //   setDomainDataFlag(domainData);
  // }, [domainData, loadingDomain]);

 
    useEffect(() => {
      if (addUpdate && resData?.[0]?.['data']?.length == 0) {
        toast.error(
          resData?.[0]?.['message'],
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        setAddUpdate(false);
      } 
    }, [loadingSubmit]);
 

  function submitFormModal() {
    handleSubmit(onFormSubmit)();
  }
  function navigateToBookingSlotPage(rowIndex) {
   
    if (rowIndex >= 0) {
      const currItem = tableData[rowIndex];
     
      user?.usertype == "user"
        ? navigate(`/bookslot/${currItem?._id}/${bookingMode}_${bookingLoc}`)
        : navigate(`/user/userListing/userbookslot/bookslotmain/add/${currItem?._id}/${bookingMode}_${bookingLoc}/${id}`);
        // : navigate(`${MODULE_URI}/bookslotmain/add/${id}/${currItem?._id}`);
    } else {
      user?.usertype == "user" ? navigate(`/bookslot}`) : navigate(MODULE_URI);
    }
  }
  function navigateTouserReviewPage(rowIndex) {
    if (rowIndex >= 0) {
      //   const currItem = expertuserSlotTableData[rowIndex];
      //   navigate(`${MODULE_URI}/viewexpuserslotbooking/${currItem?._id}`);
    } else {
      //   navigate(MODULE_URI);
    }
  }
  useEffect(() => {
    if (resData?.[0]?.['data'].length>0 && resData !== undefined ) {
      const tempData = resData?.[0]?.['data'].map((item) => {
        const subDomainNames = item.subDomain
  ?.map(sub => sub.subDomainName)
  .filter(name => !!name)
  .join(', ');

        return {
          _id: item._id,
          expertProfile: (
            <>
            <div className="expert-block">
                <div class="image-and-button">
                  <img src={`${BASE_IMG_URL}${item?.profileImagePath}`|| "https://picsum.photos/200/300/?blur"} alt="Expert Profile" className="profile-img" />
                  {/* <button className="view-profile-btn">View Profile</button> */}
                </div>
                <div className="expert-text">
                  <h2 className="exp-name text-blue">{item.expertName} </h2>
                  <p className="exp-info"> <strong>Qualification: </strong>{item.degree}</p>
                  <p className="exp-info"><strong>Specialization: </strong>{item.specialization}</p>
                  <p className="exp-info"><strong>Domain: </strong>{item.domainName}</p>
                  <p className="exp-info"><strong>Sub-Domain: </strong>{
                
                <>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
 
  <button className="btn-no-pad-dash btn-no-outline-green rounded-5"title={
   subDomainNames
                
  }
  onClick={() => {
    
    // alert(`Sub-Domains: ${subDomainNames}` || 'No subdomains available');
    setAlertData(`Sub-Domains: ${subDomainNames || "No subdomains available"}`);
    setModalOpen(true);
  }
}

  >
    View 
  </button>
</div>

              </>
              
             
                
                
                }</p>
                  <p className="exp-info"><strong>Experience: </strong>{`${item.experience} years `}</p>
                  {/* <p className="exp-info"> <MdReviews /> <strong className="text-secondary">
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  </strong>{" "}</p> */}
                   <button className="btn-sm btn-outline-navy-blue rounded-5 mt-10"  onClick={() => {
    // alert(item?.about || 'No Profile Data');
     setAlertData(item?.about || 'No Profile Data');
    setModalOpen(true);
  }}>View Profile</button>
                </div>
          </div>

            </>
          ),
        };
      });
      setTableData(tempData);
      setTotalCount(resData?.[0]?.['data'].length);
    } else {

      setTableData([]);
      setTotalCount(0);

    }
  }, [resData]);

  // const handleLocation = (e) => {
  //   // setExpAvailRespData([]); 
  //   setBookingLoc(""); 
  //   resetField("location");
  //     const selectedMode = e.target.value;
  //     setBookingMode(selectedMode);
  //     if (selectedMode === "offline") {
  //       setLocationFlag(true)
  //     } else if (selectedMode === "online") {
  //       setLocationFlag(false)
  //     } else {
  //       setLocationFlag(false)
  //     }
  //   }
 
   

    const handleDistrict = (e) => {
      setTableData([]);
      resetField("district");
      resetField("location");
      resetField("expertDomain");
      resetField("expertSubDomain");
      setTotalCount(0);


      setLocationFlag(false);
      const [stateId, stateName] = e.target.value.split("_");  
      const filteredDistricts = stateDistInfo?.find(
        (item) => item._id === stateId
      )?.districts;  
      if (filteredDistricts) {
        const districtOptions = filteredDistricts?.map((district) => ({
          id: district?._id,
          districtName: district?.districtName,
        }));

        const commonDistricts = districtOptions.filter(md =>
          districtByLoc.some(sd => sd._id === md.id && sd.districtName === md.districtName)
        );
        
        // setDistrictData( districtOptions);
        setDistrictData( commonDistricts);
        setCurrState(prev => ({
          ...prev,
          stateId,
          stateName
        }));
            } else {
          setDistrictData([]);
          setCurrState({});
      }
    };
    const handleLocation = (e) => {
      setBookingLoc("");
      setTableData([]);
      resetField("location");
      resetField("expertDomain");
      resetField("expertSubDomain");
      setTotalCount(0);


      const modeFieldValue = getValues("mode");
      setBookingMode(modeFieldValue);

        const selectedMode = e.target.value;
        const [districtId, districtName] = e.target.value.split("_");  
    
        // if (selectedMode === "offline") {
        //   setLocationFlag(true)
        // } else if (selectedMode === "online") {
        //   setLocationFlag(false)
        // } else {
        //   setLocationFlag(false)
        // }
        if (selectedMode) {
          setLocationFlag(true);
  
          setCurrDistrict(prev => ({
            ...prev,
            districtId,
            districtName
          }));
         
          getLocationData(`master/getLocationDataByStateDistrict/${currState?.stateId}/${districtId}`);
          setLocationNotiFlag(true);
        }  else {
          setLocationFlag(false);
          setLocationNotiFlag(false);
  
        }
      }
      const handleLocId = (e) => {
        setTableData([]);
        setTotalCount(0);


        resetField("expertDomain");
        resetField("expertSubDomain");

        const selectedLocation = e.target.value;  
        if (selectedLocation !== "") {
          let locationId = selectedLocation?.split('~')?.[0];
          getDomainSubDomainData(`expert/getDomainSubDomainByLocation/${locationId}/offline`);
  
          setBookingLoc(selectedLocation);
        } else {
          setBookingLoc("");
        }
      };
      console.log("domainSubDomainData?.[0]",domainSubDomainData?.[0])

      useEffect(() => {
        if(domainSubDomainData?.[0]?.success){
          const uniqueDomainDataFlag = domainSubDomainData?.[0]?.data?.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.domain === item.domain)
          );
          
          setDomainDataFlag(uniqueDomainDataFlag)
         
  
        }else if(!domainSubDomainData?.[0]?.success){
          toast.error(domainSubDomainData?.[0]?.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 200,
          });
  
        }
  
      },[domainSubDomainData])
     

      const handleSubdomain = (getValue) => {
        setTableData([]);
        setTotalCount(0);


        resetField("expertSubDomain");
        
        if (getValue.target.value !== "") {
          DomainDataFlag?.map((fetchRows, index) => {
            if (fetchRows?.domain == getValue.target.value) {
              setSubDomainFlag(fetchRows?.subDomain);
            }
          });
        } else {
          setSubDomainFlag(null);
        }
      };
      const onFormSubmit = async (data) => {

        // const toTitleCase = (str) => {
        //   return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        //     return match.toUpperCase();
        //   });
        // };
        const locationId = data.mode === "offline"?data.location.split("~")[0]:"";
        // const locationName = data.mode === "offline"?data.location.split("_")[1]:"";
    
        let formData = {
          mode:data.mode,
          locationId:locationId,
          // locationName:locationName,
          domainId: data.expertDomain,
          subDomainId: data.expertSubDomain,
          getStatus: "A",
        };
    console.log("formData test", formData);
        await axiosSubmit({
          axiosInstance: axiosInstance,
          url: SUBMIT_FORM_DATA_URL,
          method: "POST",
          requestConfig: {
            data: formData,
          },
        });
    
            setAddUpdate(true);
      };
      
      function closeModal(getCloseFlag = "false") {
        setModalOpen(getCloseFlag);
      }

  return (
    <>
                    <ViewSubDomainAlert modalOpen={modalOpen} closeModal={closeModal} alertData = {alertData} />
    
      <div className="card min-height-100">
        {user?.usertype == "admin" ? (
          <Link to={`/user/userListing/userbookslot/${id}`}>
            <button className="btn btn-blue rounded-10">
              <IoIosArrowBack />
            </button>
          </Link>
        ) : (
          <></>
        )}
        <div className="card-title text-center text-navyBlue">
          <h2>Find An Expert For Your Paramarsh </h2>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30  ">
            {/* <div className="col-md-3 ">
              <label htmlFor="mode" className="text-gray text-semi-bold">
                   Mode <span className="text-red">*</span>
                </label>
              <select
                  id="mode"
                  {...register("mode", {
                    required: {
                      value: true,
                      message: "Mode field is Required",
                    },
                  })}
                  type="text"
                  className="form-control"
                  placeholder="Select mode"
                  onChange={(e) => handleLocation(e)}
                >
                  <option value="">Select mode</option>
                  <option value="online">Online Mode</option>
                  <option value="offline">Offline Mode</option>
                  
                </select>
                <p className="text-red">{errors.mode?.message}</p>
              </div> */}
              <input
                  id="mode"
                  {...register("mode", {
                    required: {
                      value: true,
                      message: "Mode Field is Required",
                    },
                  })}
                  type="hidden"
                  className="form-control rounded-10 mb-15"
                />
                 <div className="col-md-3 ">
              <label htmlFor="state" className="text-gray text-semi-bold">
              State <span className="text-red">*</span>
                </label>
              <select
                  id="state"
                  {...register("state", {
                    required: {
                      value: true,
                      message: "State field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select State"
                  onChange={handleDistrict}

                >
                  <option value="">Select State</option>
                  {/* {stateDistInfo?.map((listFetch, index) => ( */}
                  {stateByLoc?.map((listFetch, index) => (
                        <option
                        key={listFetch?._id}

                          value={`${listFetch?._id}_${listFetch?.stateName}`}
                        >
                          {listFetch?.stateName}
                        </option>
                      ))}
                  
                </select>
                <p className="text-red">{errors.state?.message}</p>
              </div> 
              <div className="col-md-3  tank-col-info">
                    <label
                      htmlFor="district"
                      className="text-gray text-semi-bold"
                    >
                      District<span className="text-red">*</span>
                    </label>

                    <select
                      id="district"
                      {...register("district", {
                        required: {
                          value: true,
                          message: "District Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select District"
                      onChange={(e) => handleLocation(e)}
                      
                    >
                      <option value="">Select District</option>
                      {districtData?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?.id}_${listFetch?.districtName}`}
                          selected ={`${locationData[0]?.districtId}` === `${listFetch?.id}`}

                        >
                          {listFetch?.districtName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.district?.message}</p>
                  </div>
              {
                locationFlag === true?<>
                <div className="col-md-3 ">
              <label htmlFor="location" className="text-gray text-semi-bold">
                 Location <span className="text-red">*</span>
                </label>
              <select
                  id="location"
                  {...register("location", {
                    required: {
                      value: true,
                      message: "Location field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Location"
                  onChange={(e) => handleLocId(e)}
                >
                  <option value="">Select Location</option>
                  {locationData?.[0]?.success && locationData?.[0]?.data?.map((fetchRow, index) => (
                    <option value={`${fetchRow?._id}~${fetchRow?.locationName}`}>
                      {fetchRow?.locationName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.location?.message}</p>
              </div>
                </>:<></>
              }

              <div className="col-md-3  tank-col-info ">
                <label htmlFor="state" className="text-gray text-semi-bold">
                  Expert Domain <span className="text-red">*</span>
                </label>

                <select
                  id="expertDomain"
                  {...register("expertDomain", {
                    required: {
                      value: true,
                      message: "Domain field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Expert Domain"
                  onChange={(e) => handleSubdomain(e)}
                >
                  <option value="">Select Expert Domain</option>
                  {DomainDataFlag?.map((fetchRow, index) => (
                    <option value={fetchRow?.domain}>
                      {fetchRow?.domainName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.expertDomain?.message}</p>
              </div>
              <div className="col-md-3  tank-col-info">
                <label htmlFor="expertSubDomain" className="text-gray text-semi-bold">
                  Expert Sub-Domain <span className="text-red">*</span>
                </label>
                <select
                  id="expertSubDomain"
                  {...register("expertSubDomain", {
                    required: {
                      value: true,
                      message: "Expert Sub Domain field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Expert SubDomain"
                  onClick={() => {setTableData([]);setTotalCount(0);}}

                  
                 
                >
                  
                  <option value=""> Select Expert Sub-Domain </option>

                  {subDomainFlag?.map((fetchRow, index) => (
                    <option value={fetchRow?.subDomainId}>
                      {fetchRow?.subDomainName}
                    </option>
                  ))}  
                </select>
                <p className="text-red">{errors.expertSubDomain?.message}</p>
              </div>
              <div className="col-md-12 text-center">
              <input
                  type="submit"
                  className="btn btn-sm btn-secondary rounded-20"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>
        {resData?.[0]?.['data'] !== undefined  ? (
          <>
            <div className="company-table ">
              <hr className="mt-10 mb-5" />
              <h1 className="text-navyBlue text-center">
                {totalCount} Available Experts
              </h1>
              <hr className="mt-5 mb-10" />
              <BookSlotTable
                tableColumns={userBookSlotFieldData}
                tableData={tableData}
                tableSettings={{
                  page,
                  pageSize: limit,
                  totalCount,
                }}
                action={true}
                // modulePermissions={modulePermissions}
                //   handleStatus={handleStatus}
                //   handleEdit={navigateToEditPage}
                //   handleCustAsset = {navigateToCustAssetPage}
                handlePage={setPage}
                handleSlotBookingFlag={true}
                handleSlotBooking={navigateToBookingSlotPage}
                handleUserReviewFlag={true}
                handleUserReview={navigateTouserReviewPage}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default AddUserBookSlot;
